var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270.619,
    height: 159.27,
    viewBox: "0 0 270.619 159.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}.b{fill:#fafafa;}.c{fill:#ebebeb;}.d,.j,.l{fill:#fff;}.e{fill:#f5f5f5;}.f{fill:#263238;}.g{fill:none;stroke:#e0e0e0;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.h{fill:#455a64;}.i{fill:currentColor;}.j{opacity:0.2;}.k{opacity:0.6;}.l,.p{opacity:0.4;}.m,.q{opacity:0.3;}.n{fill:#ffbe9d;}.o{fill:#eb996e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.13 -61.32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.13 61.32)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16.623,
    cy: 16.623,
    r: 16.623,
    transform: "translate(171.434 32.992) rotate(-76.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M528.81,98.579a3.375,3.375,0,0,1-.587.041l-1.619.029c-1.367,0-3.28.033-5.437.037h-.107V97.5c0-2.408,0-4.59.033-6.164,0-.764.025-1.392.033-1.871a4.56,4.56,0,0,1,.041-.686,3.948,3.948,0,0,1,.041.686c0,.479.021,1.107.037,1.871,0,1.574.029,3.755.029,6.164v1.078l-.107-.107c2.156,0,4.069,0,5.437.037l1.619.033a3.739,3.739,0,0,1,.587.037Z",
    transform: "translate(-329.82 -77.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M521.269,77.63a8.793,8.793,0,0,1,0,2.793,9.134,9.134,0,0,1,0-2.793Z",
    transform: "translate(-329.872 -70.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M537.016,83.06a8.81,8.81,0,0,1-1.946,1.946,8.814,8.814,0,0,1,1.946-1.946Z",
    transform: "translate(-338.042 -74.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.161,94.77a5.725,5.725,0,0,1-1.144.764,5.784,5.784,0,0,1-1.206.665,6.2,6.2,0,0,1,2.351-1.429Z",
    transform: "translate(-343.758 -80.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M551.379,112a16.937,16.937,0,0,1-3.809,0A16.937,16.937,0,0,1,551.379,112Z",
    transform: "translate(-345.378 -90.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.754,111.387a15.086,15.086,0,0,1-3.594,0,15.087,15.087,0,0,1,3.594,0Z",
    transform: "translate(-308.163 -90.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M493.335,124.48a8,8,0,0,1-1.359,1.239,7.817,7.817,0,0,1-1.5,1.066,7.8,7.8,0,0,1,1.359-1.239A7.613,7.613,0,0,1,493.335,124.48Z",
    transform: "translate(-311.872 -98.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M505.829,134.48a11.9,11.9,0,0,1-.925,1.6,11.261,11.261,0,0,1-.983,1.57,6.2,6.2,0,0,1,.8-1.677A6.082,6.082,0,0,1,505.829,134.48Z",
    transform: "translate(-319.76 -104.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M521.269,141.979a16.935,16.935,0,0,1,0-3.809,16.309,16.309,0,0,1,0,3.809Z",
    transform: "translate(-329.872 -106.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M537.266,137.723a5.672,5.672,0,0,1-1.57-1.078,5.507,5.507,0,0,1-1.277-1.4,17.317,17.317,0,0,1,1.421,1.239,16.571,16.571,0,0,1,1.425,1.243Z",
    transform: "translate(-337.66 -104.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.3,127.841a14.294,14.294,0,0,1-2.351-2.371,6.744,6.744,0,0,1,1.264,1.107A6.608,6.608,0,0,1,547.3,127.841Z",
    transform: "translate(-343.84 -98.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M494.054,96.194a10,10,0,0,1-2.074-2.074,10,10,0,0,1,2.074,2.074Z",
    transform: "translate(-312.753 -80.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M505.577,84.118a4.858,4.858,0,0,1-1.095-.938,4.781,4.781,0,0,1-.942-1.091,9.609,9.609,0,0,1,2.037,2.028Z",
    transform: "translate(-319.537 -73.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.246,180.169h1.02l2.859-.033,10.179-.091-.087.091c-.025-5.073-.058-11.179-.091-17.764l.107.107H58.175l.1-.1v17.669a.339.339,0,0,1,0,.091.541.541,0,0,1,0-.079c0-.062,0-.14,0-.24v-.95c0-.851-.021-2.066-.037-3.619-.025-3.14-.062-7.585-.1-12.86v-.1h.1l6.7-.037h7.357c-.1-.1.136.132.112.112,0,6.568.037,12.674.054,17.764v.091h-13.9Z",
    transform: "translate(-58.13 -120.545)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.95,
    height: 0.475,
    transform: "translate(5.912 59.327)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.263,
    height: 6.159,
    transform: "translate(4.755 48.185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.95,
    height: 0.405,
    transform: "translate(6.456 41.609) rotate(-0.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 14.479,
    height: 9.758,
    transform: "translate(227.382 12.109) rotate(-5.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M623.734,96.945a1.3,1.3,0,0,1-.025-.182c0-.132-.037-.3-.062-.521-.045-.463-.116-1.124-.207-1.958-.169-1.7-.413-4.131-.715-7.048l.095.078L608.411,88.7l.095-.116h0V88.9l.029.322.062.644c.037.413.078.851.12,1.272q.12,1.264.231,2.479c.153,1.628.3,3.189.438,4.672l-.107-.091,10.365-.934,2.979-.256.8-.062h.281a1.79,1.79,0,0,1-.256.037l-.777.083-2.95.306L609.3,98.415h-.1v-.1c-.145-1.479-.293-3.045-.45-4.668l-.24-2.479c-.037-.413-.078-.826-.12-1.272l-.062-.644-.029-.322v-.314h0l.1-.12,14.413-1.347h.087v.083c.26,2.962.475,5.4.628,7.11.07.826.124,1.483.161,1.946a4.385,4.385,0,0,0,.041.5,1.253,1.253,0,0,1,0,.153Z",
    transform: "translate(-381.02 -76.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M622.947,87.34a3.833,3.833,0,0,1-.438.549l-1.264,1.454c-1.074,1.239-2.574,2.892-4.255,4.776l-.058.066-.078-.05-.384-.244c-2.206-1.4-4.2-2.689-5.635-3.627l-1.7-1.12-.454-.314c-.1-.074-.157-.116-.153-.124a.76.76,0,0,1,.173.087l.479.281,1.731,1.062c1.454.9,3.462,2.169,5.668,3.573l.384.248h-.136c1.686-1.851,3.206-3.52,4.288-4.693l1.314-1.409a5.053,5.053,0,0,1,.516-.516Z",
    transform: "translate(-381.155 -76.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.441,70.856a.9.9,0,0,0,.359-.136.71.71,0,0,0,.252-.38,3.913,3.913,0,0,0,.021-.644c0-1.008,0-2.433.025-4.189V63.378a2.04,2.04,0,0,0,0-.359.636.636,0,0,0-.157-.293.566.566,0,0,0-.293-.157,3.689,3.689,0,0,0-.38,0H422.134a.574.574,0,0,0-.545.537v.987c0,.657,0,1.3-.029,1.937-.021,1.272-.041,2.479-.062,3.668v.438a.578.578,0,0,0,.087.355.541.541,0,0,0,.269.231,1.09,1.09,0,0,0,.38.037h4.5l4.189.033h1.14l-1.14.021-4.189.033h-4.5a1.239,1.239,0,0,1-.446-.05.739.739,0,0,1-.368-.306.826.826,0,0,1-.12-.463v-.413c0-1.173.033-2.4.05-3.668,0-.636,0-1.285.025-1.942v-1a.789.789,0,0,1,.773-.727h10.134a2.916,2.916,0,0,1,.413,0,.735.735,0,0,1,.384.211.748.748,0,0,1,.2.384,1.87,1.87,0,0,1,0,.413v.739c0,.479-.021.942-.029,1.388-.037,1.752-.07,3.177-.091,4.185a4.02,4.02,0,0,1-.045.661.719.719,0,0,1-.289.413.649.649,0,0,1-.285.1A.3.3,0,0,1,432.441,70.856Z",
    transform: "translate(-271.27 -61.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M434.791,69.955l1.409.855-1.442.847-1.438.843.029-1.7.029-1.7Z",
    transform: "translate(-278.326 -65.886)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M123.635,61.32H103.17V88l20.465.512Z",
    transform: "translate(-84.564 -61.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M123.714,63.62h-17.9v24.2l17.9.6Z",
    transform: "translate(-86.113 -62.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M124.975,73.62l-11.885-.45V90.083h11.885Z",
    transform: "translate(-90.386 -68.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M113.09,90.083l11.885-8.688L113.09,73.17Z",
    transform: "translate(-90.386 -68.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M509.145,332.794c-7.49-5.23-9.187-14.942-8.89-23.671.05-1.458-.112-3,.582-4.272a2.972,2.972,0,0,1,3.615-1.541c1.082.512,1.553,1.768,2.161,2.809a8.485,8.485,0,0,0,3.416,3.264,3.242,3.242,0,0,0,2.991.273c1.239-.694,1.4-2.429,1.4-3.879l-.05-8.105a14.176,14.176,0,0,1,.438-4.3,4.456,4.456,0,0,1,2.826-3.036,2.733,2.733,0,0,1,3.375,1.826,13.816,13.816,0,0,1,.041,1.805,1.517,1.517,0,0,0,.888,1.434,1.774,1.774,0,0,0,1.595-.665,19.182,19.182,0,0,0,3.458-5.222,26.665,26.665,0,0,1,3.226-5.391,7.847,7.847,0,0,1,5.313-2.979,4.686,4.686,0,0,1,4.809,3.2c.525,2.037-.665,4.131-1.962,5.784a32.426,32.426,0,0,1-6.734,6.42,2.636,2.636,0,0,0-1.128,1.21c-.314.967.6,1.925,1.553,2.243a16.778,16.778,0,0,0,3.383.38,3.254,3.254,0,0,1,2.78,1.7c.595,1.479-.644,3.032-1.863,4.048a27.641,27.641,0,0,1-8.2,4.734,9.426,9.426,0,0,0-3.049,1.483c-.859.748.475,3.4,1,4.42s0,0,1.115-.207a20.644,20.644,0,0,0,3.181-1.215c1.991-.752,4.544-.616,5.837,1.107a4.623,4.623,0,0,1,.487,4.057,10.575,10.575,0,0,1-2.194,3.582,27.894,27.894,0,0,1-11.9,8.361c-4.619,1.6-8.9,2.037-13.492.355",
    transform: "translate(-317.59 -190.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M521.55,341.016a63.517,63.517,0,0,1,2.367-11.947,129.754,129.754,0,0,1,5.156-13.98c.516-1.215,1.033-2.413,1.537-3.594s1.012-2.351,1.574-3.462a65.5,65.5,0,0,1,3.6-6.2c1.239-1.917,2.479-3.693,3.668-5.346s2.313-3.173,3.4-4.511a51.675,51.675,0,0,1,5.614-5.932c.715-.644,1.285-1.128,1.677-1.45l.446-.364a1.081,1.081,0,0,1,.161-.116,1.274,1.274,0,0,1-.145.136l-.413.384c-.38.335-.938.826-1.652,1.487a54.511,54.511,0,0,0-5.536,5.974c-1.078,1.347-2.2,2.867-3.375,4.519s-2.408,3.437-3.644,5.37a66.129,66.129,0,0,0-3.573,6.2c-.558,1.107-1.058,2.264-1.566,3.449s-1.02,2.38-1.537,3.594a131.93,131.93,0,0,0-5.164,13.947,64.446,64.446,0,0,0-2.413,11.864",
    transform: "translate(-330.107 -192.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M544.475,319.352a3.031,3.031,0,0,1-.141-.615c-.078-.413-.169-.983-.269-1.706-.207-1.442-.413-3.445-.649-5.655s-.475-4.2-.7-5.639c-.112-.719-.207-1.3-.281-1.7a2.8,2.8,0,0,1-.078-.628,3.241,3.241,0,0,1,.182.607c.1.392.227.971.359,1.685.277,1.434.549,3.433.781,5.643s.413,4.152.57,5.66c.07.682.132,1.239.182,1.714A2.889,2.889,0,0,1,544.475,319.352Z",
    transform: "translate(-342.32 -203.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M566.117,333.528a3.842,3.842,0,0,1-.744.091c-.475.041-1.169.1-2.02.2-1.706.186-4.057.521-6.61,1.008s-4.912,1.033-6.564,1.471c-.826.215-1.5.413-1.962.537a3.626,3.626,0,0,1-.727.178,4.225,4.225,0,0,1,.694-.277c.454-.161,1.12-.38,1.946-.62,1.652-.492,3.966-1.062,6.548-1.557a66.7,66.7,0,0,1,6.659-.93c.859-.074,1.557-.1,2.037-.112A4.363,4.363,0,0,1,566.117,333.528Z",
    transform: "translate(-345.331 -221.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M514.5,358.305a1.089,1.089,0,0,1-.128-.227l-.318-.673c-.273-.587-.649-1.446-1.095-2.512-.9-2.136-2.066-5.123-3.272-8.436s-2.346-6.312-3.2-8.46c-.413-1.045-.764-1.9-1.02-2.545l-.273-.694a1.039,1.039,0,0,1-.078-.248.892.892,0,0,1,.128.227c.087.182.194.413.318.673.277.587.649,1.446,1.1,2.512.9,2.136,2.066,5.123,3.272,8.44s2.342,6.308,3.2,8.456l1.016,2.545c.112.277.2.508.273.694A.88.88,0,0,1,514.5,358.305Z",
    transform: "translate(-320.465 -221.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M552.586,372.8a1.194,1.194,0,0,1-.248.1l-.719.244-2.656.859c-2.239.723-5.317,1.764-8.721,2.912s-6.494,2.165-8.75,2.846c-1.128.339-2.041.6-2.677.777l-.735.19a.827.827,0,0,1-.26.05,1.2,1.2,0,0,1,.248-.1l.719-.24,2.648-.859c2.239-.727,5.321-1.768,8.725-2.917s6.494-2.165,8.75-2.846c1.128-.339,2.041-.6,2.677-.777l.735-.19A.826.826,0,0,1,552.586,372.8Z",
    transform: "translate(-333.787 -244.125)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.175 219.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M58.24,445.177c0-.062,60.574-.107,135.281-.107s135.293.045,135.293.107-60.562.107-135.293.107S58.24,445.235,58.24,445.177Z",
    transform: "translate(-58.24 -445.07)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.207 83.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M171.524,172.435s-7.738,83.535,8.386,110.391l143.407,1.694s-23.754-72.41-21.7-114.27Z",
    transform: "translate(-169.668 -147.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M172.187,175.54s-9.088,86.137,19.23,104.545h138.21s-24.53-42.05-26.464-104.545Z",
    transform: "translate(-170.331 -150.696)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 134.459,
    height: 21.56,
    transform: "translate(1.154 4.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M201.55,120.271s1.355-4.871,6.3-4.871a6.211,6.211,0,0,1,6.3,6.478,6.337,6.337,0,0,1-6.3,6.61",
    transform: "translate(-188.379 -115.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 6.635,
    height: 2.962,
    transform: "translate(11.171 4.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M263.38,120.271s1.355-4.871,6.3-4.871a6.211,6.211,0,0,1,6.3,6.478,6.337,6.337,0,0,1-6.3,6.61",
    transform: "translate(-224.667 -115.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 6.635,
    height: 2.962,
    transform: "translate(36.718 4.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M325.22,120.271s1.355-4.871,6.3-4.871a6.211,6.211,0,0,1,6.3,6.478,6.337,6.337,0,0,1-6.3,6.61",
    transform: "translate(-260.96 -115.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 6.635,
    height: 2.962,
    transform: "translate(62.261 4.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M387.05,120.271s1.355-4.871,6.3-4.871a6.211,6.211,0,0,1,6.3,6.478,6.338,6.338,0,0,1-6.3,6.61",
    transform: "translate(-297.247 -115.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 6.635,
    height: 2.962,
    transform: "translate(87.807 4.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M448.89,120.271s1.355-4.871,6.3-4.871a6.211,6.211,0,0,1,6.3,6.478,6.337,6.337,0,0,1-6.3,6.61",
    transform: "translate(-333.541 -115.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 6.635,
    height: 2.962,
    transform: "translate(113.35 4.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M172.474,180.91S170.987,276.9,202.1,276.9l127.812.045s-18.268-18.639-23.679-96.04Z",
    transform: "translate(-171.308 -153.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M328.516,278.449c-.029-.083-.165-.471-.467-1.314s-.768-2.132-1.326-3.825c-1.144-3.367-2.743-8.345-4.573-14.777a436.684,436.684,0,0,1-11.567-54.679l.087.074h-109.4l.107-.124c1.95,13.9,3.953,27.443,7.2,40.129a144.307,144.307,0,0,0,5.879,18.235A106.607,106.607,0,0,0,222.57,278.4l-.083-.045,106.024.1-106.024.1h-.054l-.029-.045a106.83,106.83,0,0,1-8.155-16.235,144.864,144.864,0,0,1-5.891-18.255c-3.251-12.7-5.255-26.253-7.209-40.154v-.124h1.157l108.371.021h.074v.074A442.68,442.68,0,0,0,322.245,258.5c1.818,6.436,3.4,11.418,4.544,14.789S328.462,278.28,328.516,278.449Z",
    transform: "translate(-188.144 -167.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M326.766,294.007c0,.062-24.406.107-54.506.107s-54.53-.045-54.53-.107,24.4-.107,54.53-.107S326.766,293.941,326.766,294.007Z",
    transform: "translate(-197.875 -220.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M340.951,342.277c0,.058-24.415.107-54.53.107s-54.53-.05-54.53-.107,24.406-.107,54.53-.107S340.951,342.215,340.951,342.277Z",
    transform: "translate(-206.185 -248.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M317.836,247.5c0,.058-24.406.107-54.506.107s-54.53-.05-54.53-.107,24.4-.107,54.53-.107S317.836,247.435,317.836,247.5Z",
    transform: "translate(-192.634 -192.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.528,278.6s-.025-.062-.066-.186-.1-.318-.178-.554c-.157-.5-.38-1.219-.669-2.136-.578-1.855-1.388-4.544-2.367-7.878-1.946-6.668-4.524-15.913-7.023-26.216-1.239-5.151-2.351-10.08-3.3-14.574s-1.735-8.555-2.342-11.98c-.318-1.71-.578-3.259-.826-4.619s-.413-2.532-.57-3.491-.26-1.7-.339-2.21c-.033-.248-.062-.438-.083-.578a1.575,1.575,0,0,1-.021-.194,1.678,1.678,0,0,1,.045.19c.025.14.058.33.1.574l.376,2.2c.157.958.364,2.132.607,3.487s.512,2.892.826,4.61c.628,3.416,1.446,7.469,2.388,11.98s2.066,9.415,3.3,14.566c2.479,10.3,5.044,19.548,6.953,26.224.958,3.334,1.743,6.031,2.3,7.895.269.925.479,1.652.628,2.144l.157.562A.51.51,0,0,1,270.528,278.6Z",
    transform: "translate(-218.422 -167.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M321.764,278.607s-.025-.062-.066-.19l-.173-.554-.653-2.14c-.566-1.855-1.359-4.544-2.326-7.886-1.917-6.676-4.511-15.917-7.023-26.212s-4.507-19.693-5.73-26.53c-.314-1.706-.587-3.255-.8-4.619s-.413-2.532-.558-3.495-.248-1.694-.322-2.21c-.033-.248-.058-.438-.078-.578S304,204,304,204a.746.746,0,0,0,.041.194l.1.57c.087.516.207,1.239.364,2.206s.355,2.132.591,3.491.512,2.892.826,4.61c1.26,6.825,3.247,16.215,5.784,26.505s5.09,19.532,6.969,26.216l2.264,7.911c.264.925.467,1.652.611,2.148l.153.562A1.41,1.41,0,0,1,321.764,278.607Z",
    transform: "translate(-248.506 -167.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M375.277,278.637a1.932,1.932,0,0,1-.07-.186c-.041-.136-.1-.318-.182-.554l-.673-2.136c-.591-1.851-1.413-4.544-2.417-7.849-1.983-6.659-4.664-15.88-7.225-26.17s-4.511-19.718-5.635-26.559c-.285-1.71-.537-3.264-.727-4.631s-.372-2.541-.483-3.507-.207-1.7-.268-2.223c-.029-.244-.05-.438-.066-.578a.542.542,0,0,1,0-.194.915.915,0,0,0,.033.194l.087.574c.074.516.178,1.239.31,2.214s.31,2.14.521,3.5.463,2.912.756,4.623c1.165,6.849,3.115,16.252,5.693,26.534s5.218,19.511,7.167,26.179c.987,3.326,1.789,6.015,2.346,7.886.273.925.487,1.652.636,2.148q.1.355.161.558C375.264,278.571,375.277,278.637,375.277,278.637Z",
    transform: "translate(-279.918 -167.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M428.764,278.607a1.94,1.94,0,0,1-.07-.186l-.186-.554c-.165-.5-.413-1.21-.7-2.128-.6-1.847-1.454-4.544-2.479-7.849-2.066-6.643-4.817-15.847-7.436-26.129-1.322-5.139-2.479-10.063-3.388-14.57-.487-2.247-.872-4.4-1.239-6.407q-.26-1.512-.5-2.917c-.161-.934-.31-1.834-.413-2.693C411.256,208.3,411,204,411,204a.992.992,0,0,0,.029.194c.029.128.041.331.07.578.058.521.136,1.268.244,2.227s.26,2.144.438,3.511.413,2.925.673,4.639c.124.859.281,1.76.446,2.693s.335,1.9.508,2.912c.392,2,.785,4.152,1.272,6.395.938,4.5,2.086,9.423,3.4,14.562,2.623,10.274,5.37,19.482,7.378,26.133l2.421,7.87c.285.921.508,1.652.661,2.14.07.24.124.413.165.558S428.764,278.607,428.764,278.607Z",
    transform: "translate(-311.304 -167.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M260.339,215.659s.93,9.051,4.524,14.7h21.164s-5.143-9.154-5.784-15.516l-.463-3.565H260Z",
    transform: "translate(-222.683 -171.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M284.219,225.567c0,.062-3.012.107-6.73.107s-6.73-.045-6.73-.107,3.012-.107,6.73-.107S284.219,225.51,284.219,225.567Z",
    transform: "translate(-228.998 -179.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.879,231.107c0,.062-3.012.107-6.73.107s-6.73-.045-6.73-.107,3.012-.107,6.73-.107S285.879,231.05,285.879,231.107Z",
    transform: "translate(-229.972 -183.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.467,236.647c0,.058-3.012.107-6.73.107s-6.738-.05-6.738-.107,3.012-.107,6.73-.107S287.467,236.59,287.467,236.647Z",
    transform: "translate(-230.899 -186.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M289.109,242.187c0,.058-3.012.107-6.73.107s-6.73-.05-6.73-.107,3.012-.107,6.73-.107S289.109,242.125,289.109,242.187Z",
    transform: "translate(-231.868 -189.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M436.125,269.663s.929,9.051,4.524,14.7H461.8s-5.143-9.15-5.784-15.512l-.463-3.569H435.77Z",
    transform: "translate(-325.841 -203.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M460.029,278.477c0,.062-3.012.107-6.73.107s-6.73-.045-6.73-.107,3.016-.107,6.73-.107S460.029,278.42,460.029,278.477Z",
    transform: "translate(-332.179 -211.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M461.659,284.017c0,.058-3.012.107-6.73.107s-6.73-.05-6.73-.107,3.012-.107,6.73-.107S461.659,283.947,461.659,284.017Z",
    transform: "translate(-333.136 -214.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M463.289,289.557c0,.058-3.012.107-6.73.107s-6.73-.05-6.73-.107,3.012-.107,6.73-.107S463.289,289.5,463.289,289.557Z",
    transform: "translate(-334.092 -217.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M464.879,295.1c0,.058-3.012.107-6.73.107s-6.73-.05-6.73-.107,3.012-.107,6.73-.107S464.879,295.035,464.879,295.1Z",
    transform: "translate(-335.026 -220.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M382.527,208.077c.219.178-2.52,3.825-6.659,7.6s-8,6.2-8.155,5.969,3.359-3.024,7.436-6.763S382.287,207.875,382.527,208.077Z",
    transform: "translate(-285.896 -169.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M383.97,222.561c-.173.244-4.8-2.764-10.489-6.478s-10.3-6.742-10.146-7.023,5.023,2.367,10.741,6.1S384.139,222.322,383.97,222.561Z",
    transform: "translate(-283.327 -170.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M316.649,222.27c-.182-.235,2.863-2.855,6.8-5.85s7.267-5.23,7.436-4.994-2.863,2.855-6.8,5.85S316.827,222.505,316.649,222.27Z",
    transform: "translate(-255.925 -171.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M330.6,223.809c-.19.248-4.238-2.607-9.382-5.887s-9.419-5.784-9.278-6.044,4.68,1.818,9.861,5.139S330.773,223.586,330.6,223.809Z",
    transform: "translate(-253.161 -172.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M342.993,297.981c0-.033.211-.083.624-.112a6.886,6.886,0,0,1,1.809.182,8.213,8.213,0,0,1,2.66,1.14,8.419,8.419,0,0,1,2.673,2.784,9.064,9.064,0,0,1,1.219,4.544,9.944,9.944,0,0,1-.33,2.619,9.649,9.649,0,0,1-1.132,2.574,10.642,10.642,0,0,1-10.828,4.722,10.807,10.807,0,0,1-5.7-2.892,9.807,9.807,0,0,1-2.755-5.3,10.076,10.076,0,0,1,.5-5.37,8.643,8.643,0,0,1,2.8-3.763,9.349,9.349,0,0,1,3.462-1.681,8.472,8.472,0,0,1,2.892-.24,3.806,3.806,0,0,1,.558.07c.173.029.335.05.483.087.293.083.541.14.735.219.384.157.578.256.566.289-.033.1-.826-.24-2.363-.248a8.847,8.847,0,0,0-2.7.413,9.013,9.013,0,0,0-3.148,1.7,7.985,7.985,0,0,0-2.441,3.482,9.245,9.245,0,0,0-.355,4.875,8.857,8.857,0,0,0,2.5,4.714,9.828,9.828,0,0,0,5.151,2.582,9.6,9.6,0,0,0,5.709-.706,9.721,9.721,0,0,0,4.1-3.491,8.733,8.733,0,0,0,1.053-2.289,9.152,9.152,0,0,0,.351-2.367,8.477,8.477,0,0,0-.987-4.131,8.052,8.052,0,0,0-2.355-2.665,8.482,8.482,0,0,0-2.429-1.239A22.908,22.908,0,0,0,342.993,297.981Z",
    transform: "translate(-264.394 -222.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M217.651,267.842c-.223-.186,2.38-3.718,6.036-7.725,3.594-3.937,6.891-6.969,7.155-6.7s-2.731,3.449-6.362,7.436S217.887,268.032,217.651,267.842Z",
    transform: "translate(-197.821 -196.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M232.207,268.173c-.157.252-4.383-2.066-9.44-5.2s-9.031-5.866-8.874-6.118,4.334,2.066,9.394,5.2S232.364,267.921,232.207,268.173Z",
    transform: "translate(-195.621 -198.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M347.289,306.661l1.615,2.318a.694.694,0,0,0,.587.306h2.826a.715.715,0,0,1,.574,1.144l-1.706,2.251a.71.71,0,0,0-.107.653l.888,2.681a.711.711,0,0,1-.909.9l-2.669-.925a.731.731,0,0,0-.657.1l-2.276,1.677a.711.711,0,0,1-1.132-.591l.054-2.822a.719.719,0,0,0-.3-.595l-2.293-1.652a.706.706,0,0,1,.207-1.239l2.706-.826a.719.719,0,0,0,.471-.467l.855-2.689a.715.715,0,0,1,1.264-.219Z",
    transform: "translate(-270.515 -227.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M438.126,208.314c.2.219-3.4,3.768-8.039,7.919s-8.56,7.337-8.758,7.114,3.4-3.763,8.039-7.915S437.923,208.091,438.126,208.314Z",
    transform: "translate(-317.361 -169.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M437.2,223.484c-.132.264-5.176-2-11.261-5.044s-10.918-5.742-10.782-6.011,5.172,2,11.261,5.048S437.332,223.22,437.2,223.484Z",
    transform: "translate(-313.741 -172.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M449.83,219.84h24.634l5.912,4.573-5.213,4.276-23.617-.025Z",
    transform: "translate(-334.092 -176.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M347.289,306.661l1.615,2.318a.694.694,0,0,0,.587.306h2.826a.715.715,0,0,1,.574,1.144l-1.706,2.251a.71.71,0,0,0-.107.653l.888,2.681a.711.711,0,0,1-.909.9l-2.669-.925a.731.731,0,0,0-.657.1l-2.276,1.677a.711.711,0,0,1-1.132-.591l.054-2.822a.719.719,0,0,0-.3-.595l-2.293-1.652a.706.706,0,0,1,.207-1.239l2.706-.826a.719.719,0,0,0,.471-.467l.855-2.689a.715.715,0,0,1,1.264-.219Z",
    transform: "translate(-270.515 -227.477)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.482 100.363)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M600.679,435.358l.021-3.478h6.515l.025,5.085-.413.029c-1.8.1-9.146.388-10.328.025C595.147,436.606,600.679,435.358,600.679,435.358Z",
    transform: "translate(-564.321 -317.841)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(40.563 117.285)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M617.1,441.606a2.248,2.248,0,0,1,.826-1.388,2.2,2.2,0,0,1,1.52-.475v1.822Z",
    transform: "translate(-617.1 -439.738)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(31.949 118.22)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M597.964,442s-1.937.562-1.694.88,7.676.31,10.956,0v-.145l-8.675.087S598.344,442,597.964,442Z",
    transform: "translate(-596.249 -442)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M607.211,443.671h-.434l-1.186.05c-1,.037-2.38.07-3.908.074s-2.892-.025-3.908-.058l-1.182-.045-.322-.021h.322l1.186.025c1,0,2.38.037,3.9.033s2.892-.029,3.908-.05l1.186-.029h.413Z",
    transform: "translate(-564.247 -324.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M600.9,442.886a2.6,2.6,0,0,0-.223-.562,2.924,2.924,0,0,0-.413-.454.884.884,0,0,1,.471.413A.872.872,0,0,1,600.9,442.886Z",
    transform: "translate(-566.654 -323.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M606.257,440.83a1.263,1.263,0,0,1-.207-.252c-.095-.153-.157-.277-.136-.289s.107.1.2.248A.723.723,0,0,1,606.257,440.83Z",
    transform: "translate(-569.97 -322.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M607.417,440.4a1.02,1.02,0,0,1-.231-.153c-.112-.1-.19-.194-.178-.211s.116.054.231.153S607.442,440.384,607.417,440.4Z",
    transform: "translate(-570.613 -322.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M607.862,439.374c0,.025-.153.041-.339.045s-.343,0-.343-.037a.781.781,0,0,1,.343-.041A.769.769,0,0,1,607.862,439.374Z",
    transform: "translate(-570.715 -322.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M607.983,438.38a.673.673,0,0,1-.38.112.718.718,0,0,1-.413-.05,1.79,1.79,0,0,1,.384-.029A2.158,2.158,0,0,1,607.983,438.38Z",
    transform: "translate(-570.721 -321.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M604.474,439.4a1.238,1.238,0,0,1-.413,0,2.474,2.474,0,0,1-.446-.1,1.281,1.281,0,0,1-.256-.1.227.227,0,0,1-.1-.132.161.161,0,0,1,.066-.165.764.764,0,0,1,.946.223.7.7,0,0,1,.136.277.172.172,0,0,1,0,.116,1.14,1.14,0,0,0-.19-.359.826.826,0,0,0-.359-.231.649.649,0,0,0-.5.037c-.066.05-.041.128.033.169a1.091,1.091,0,0,0,.235.1,2.365,2.365,0,0,0,.413.111C604.317,439.386,604.474,439.386,604.474,439.4Z",
    transform: "translate(-568.41 -321.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M605.919,439.12a.413.413,0,0,1-.05-.289.724.724,0,0,1,.116-.306.434.434,0,0,1,.347-.215.165.165,0,0,1,.128.194.372.372,0,0,1-.07.186,1.375,1.375,0,0,1-.194.256.611.611,0,0,1-.24.169,2.39,2.39,0,0,0,.2-.211,1.61,1.61,0,0,0,.174-.248c.058-.091.095-.248,0-.269s-.211.1-.277.178a.694.694,0,0,0-.116.273,1.336,1.336,0,0,0-.017.281Z",
    transform: "translate(-569.941 -321.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M619.714,439.586s-.186,0-.479.021a2.1,2.1,0,0,0-1.049.413,2.132,2.132,0,0,0-.657.925c-.1.281-.107.467-.124.467a.538.538,0,0,1,0-.132,2.065,2.065,0,0,1,.07-.351,1.991,1.991,0,0,1,1.752-1.4,1.9,1.9,0,0,1,.359,0A.441.441,0,0,1,619.714,439.586Z",
    transform: "translate(-576.713 -322.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M621.338,432.63a22.842,22.842,0,0,1,.037,2.677A22.828,22.828,0,0,1,621.338,432.63Z",
    transform: "translate(-579.01 -318.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M612.71,442.2a3.637,3.637,0,0,1-.95.1,3.574,3.574,0,0,1-.95-.074c0-.025.413,0,.95,0S612.71,442.175,612.71,442.2Z",
    transform: "translate(-572.845 -323.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M618.236,442.2s-.033.091-.074.19-.07.182-.091.182-.033-.1,0-.215S618.224,442.18,618.236,442.2Z",
    transform: "translate(-577.095 -323.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M619.32,440.745a.484.484,0,0,1-.1.153c-.066.07-.136.112-.149.1s.025-.083.091-.153S619.3,440.728,619.32,440.745Z",
    transform: "translate(-577.695 -323.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M620.8,440.03c0,.021-.091.021-.186.054s-.165.087-.182.07.037-.1.157-.145S620.812,439.993,620.8,440.03Z",
    transform: "translate(-578.493 -322.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M622.237,439.748c0,.021-.029.054-.083.074s-.107.025-.116,0,.033-.054.087-.074S622.229,439.727,622.237,439.748Z",
    transform: "translate(-579.435 -322.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M552.257,162.41l57.331,2.309v13.219L551.41,175.8Z",
    transform: "translate(-537.984 -159.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M522.946,174.24s-3.264-.388-4.036,1.016c0,0,.661,1.785,3.9,1.652Z",
    transform: "translate(-518.91 -166.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M527.536,166.71l-.326,3.656,3.929.384a6.022,6.022,0,0,1,3.478,2.136c1.863,2,2.6,2.917,2.6,2.917l.847-13.393-2.582,2.421a6.3,6.3,0,0,1-1.743,1.153,9.8,9.8,0,0,1-2.45.826A28.045,28.045,0,0,1,527.536,166.71Z",
    transform: "translate(-523.781 -159.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M692.24,168s3.458,1.979,2.768,7.093c-.591,4.408-2.768,6.131-2.768,6.131Z",
    transform: "translate(-620.636 -162.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M552.495,174.23l57.6,2.107v3.578l-57.819-2.3Z",
    transform: "translate(-538.495 -166.628)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(43.232 4.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.46,167.69c.9.066,1.5.934,2.284,1.367s1.727.413,2.479.855a2.479,2.479,0,0,1,.5,3.933c-.673.64-1.76.991-1.958,1.9-.087.413-.145,1.025-.554.958-.227-.033-.339-.289-.5-.446a.991.991,0,0,0-1.314.149,6.6,6.6,0,0,0-.826,1.215,1.388,1.388,0,0,1-1.177.735V180.1l-2.826-.14.318-11.505Z",
    transform: "translate(-623.56 -167.69)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M645.92,435.864V432.39h-6.535l-.025,5.085.413.025c1.8.1,9.142.388,10.328.025C651.452,437.116,645.92,435.864,645.92,435.864Z",
    transform: "translate(-589.601 -318.14)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(49.767 117.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M641.726,442.115a2.255,2.255,0,0,0-.826-1.392,2.181,2.181,0,0,0-1.52-.471v1.818Z",
    transform: "translate(-639.38 -440.246)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(49.751 118.426)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M648.6,442.5s1.938.562,1.694.88-7.676.31-10.956.021v-.149l8.675.087S648.222,442.517,648.6,442.5Z",
    transform: "translate(-639.34 -442.5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M639.25,444.2a.389.389,0,0,0,.112,0h.322l1.186.054c1,.037,2.38.07,3.908.074s2.892-.025,3.908-.058l1.182-.05h.021l-1.186.021c-1,.021-2.379.037-3.9.033s-2.892-.025-3.908-.05L639.7,444.2h-.454Z",
    transform: "translate(-589.536 -325.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M660.353,443.39a2.513,2.513,0,0,1,.223-.566,2.922,2.922,0,0,1,.413-.454.9.9,0,0,0-.471.413A.868.868,0,0,0,660.353,443.39Z",
    transform: "translate(-601.919 -323.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M655.4,441.33a1.309,1.309,0,0,0,.207-.248c.095-.149.157-.281.136-.293s-.107.1-.2.248S655.384,441.317,655.4,441.33Z",
    transform: "translate(-599.015 -323.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M654.128,440.9a.874.874,0,0,0,.231-.153c.112-.1.19-.194.178-.211s-.12.054-.231.153S654.116,440.888,654.128,440.9Z",
    transform: "translate(-598.268 -322.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M653.33,439.908a.769.769,0,0,0,.339.041.793.793,0,0,0,.351-.017c0-.025-.153-.041-.343-.045S653.33,439.883,653.33,439.908Z",
    transform: "translate(-597.8 -322.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M653.05,438.89a.731.731,0,0,0,.38.107.649.649,0,0,0,.392-.05,1.791,1.791,0,0,0-.38-.012A1.943,1.943,0,0,0,653.05,438.89Z",
    transform: "translate(-597.636 -321.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M656,439.908a1.174,1.174,0,0,0,.413,0,2.809,2.809,0,0,0,.446-.1,1.421,1.421,0,0,0,.256-.107.219.219,0,0,0,.1-.128.169.169,0,0,0-.066-.169.764.764,0,0,0-.946.223.826.826,0,0,0-.14.281.215.215,0,0,0,0,.112,1.1,1.1,0,0,1,.19-.355.735.735,0,0,1,.359-.231.628.628,0,0,1,.5.033c.066.05.041.128-.033.174a1.342,1.342,0,0,1-.235.1,3.309,3.309,0,0,1-.413.112A3.928,3.928,0,0,0,656,439.908Z",
    transform: "translate(-599.367 -322.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M655.432,439.63a.45.45,0,0,0,.05-.293.743.743,0,0,0-.116-.306.413.413,0,0,0-.347-.211.165.165,0,0,0-.132.19.457.457,0,0,0,.074.19,1.483,1.483,0,0,0,.194.252.611.611,0,0,0,.24.169,2.655,2.655,0,0,1-.2-.207,1.41,1.41,0,0,1-.174-.252c-.058-.091-.095-.248,0-.269s.211.1.277.182a.657.657,0,0,1,.116.269A1.878,1.878,0,0,1,655.432,439.63Z",
    transform: "translate(-598.712 -321.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M639.15,440.07h.479a2.1,2.1,0,0,1,1.049.413,2.14,2.14,0,0,1,.657.93,4.443,4.443,0,0,1,.12.463v-.132a1.859,1.859,0,0,0-.074-.351,1.971,1.971,0,0,0-1.747-1.4,1.6,1.6,0,0,0-.359,0,.444.444,0,0,0-.124.074Z",
    transform: "translate(-589.478 -322.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M640.692,433.13a12.374,12.374,0,0,0-.058,1.338,11.168,11.168,0,0,0,.021,1.338A22.841,22.841,0,0,0,640.692,433.13Z",
    transform: "translate(-590.342 -318.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M646.74,442.7a3.673,3.673,0,0,0,.95.1,3.594,3.594,0,0,0,.954-.074c0-.021-.413,0-.95,0S646.744,442.681,646.74,442.7Z",
    transform: "translate(-593.932 -324.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M643.65,442.7l.078.19c.041.1.07.186.091.182s.033-.1,0-.215S643.667,442.685,643.65,442.7Z",
    transform: "translate(-592.119 -324.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M642.49,441.247a.441.441,0,0,0,.095.153c.066.066.132.112.149.1s-.025-.083-.091-.149S642.507,441.235,642.49,441.247Z",
    transform: "translate(-591.438 -323.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M640.829,440.536c0,.021.091.021.186.054s.165.087.182.07-.037-.1-.157-.145S640.821,440.515,640.829,440.536Z",
    transform: "translate(-590.463 -322.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M639.64,440.258c0,.021.029.054.083.074s.107.021.112,0-.029-.054-.083-.074S639.648,440.237,639.64,440.258Z",
    transform: "translate(-589.765 -322.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M575.412,199.2s-10.1,4.272-10.423,4.131-.558-7.969-.558-7.969l-5.04-.186s-.942,11.922,2.066,13.856c4.131,2.644,14.161-2.855,14.161-2.855Z",
    transform: "translate(-542.586 -178.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M606.737,175.725v-2.363a3.041,3.041,0,0,1-2.706-2.8c-.157-2.528,0-8.357,0-8.357l4.643-2.268,5.106,3.867-.537,12.034a3.247,3.247,0,0,1-3.243,3.1h0A3.243,3.243,0,0,1,606.737,175.725Z",
    transform: "translate(-568.826 -158.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M605.4,175.262a.326.326,0,1,0,.322-.322A.322.322,0,0,0,605.4,175.262Z",
    transform: "translate(-569.67 -167.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M604.632,174.306c.041.045.281-.161.632-.178s.607.149.644.1-.025-.1-.14-.178a.851.851,0,0,0-.521-.136.826.826,0,0,0-.5.2C604.649,174.207,604.612,174.289,604.632,174.306Z",
    transform: "translate(-569.216 -166.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M614.48,175.262a.322.322,0,1,0,.322-.322A.322.322,0,0,0,614.48,175.262Z",
    transform: "translate(-574.999 -167.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M613.988,174.306c.041.045.281-.161.628-.178s.611.149.649.1-.029-.1-.141-.178a.863.863,0,0,0-1.02.062C613.988,174.207,613.963,174.29,613.988,174.306Z",
    transform: "translate(-574.705 -166.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M609.691,177.7a1.653,1.653,0,0,1-.574.054.8.8,0,0,1-.161,0,.235.235,0,0,1-.165-.145.566.566,0,0,1,.029-.384l.223-.727a9.533,9.533,0,0,1,.7-1.826,8.784,8.784,0,0,1-.5,1.892l-.26.723a.467.467,0,0,0-.054.256c0,.045.074.066.165.07C609.451,177.628,609.691,177.661,609.691,177.7Z",
    transform: "translate(-571.648 -166.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M615,181.642c0,.289.45.5.987.508s.987-.178,1-.463-.413-.566-.987-.578S615,181.357,615,181.642Z",
    transform: "translate(-575.304 -170.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M611.341,182.721a6.448,6.448,0,0,1-1.681.582.963.963,0,0,0,1.153.326C611.556,183.316,611.341,182.721,611.341,182.721Z",
    transform: "translate(-572.17 -171.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M610.34,190.822a6.279,6.279,0,0,0,3.346-1.132,3.267,3.267,0,0,1-3.3,1.752Z",
    transform: "translate(-572.569 -175.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M616.979,163.5v.45c-.054-.467-.186-1.533-.26-1.822a8.086,8.086,0,0,0-6.928-6.254c-.983,0-2.7-.537-5.209,2.066a4.87,4.87,0,0,0-1.12,5.4l.413-.388,3.718-.954a4.625,4.625,0,0,1,.38-2.809l.025-.025c.735,3.784,4.9,4.177,4.9,4.177l-.351,7.023C617.508,169.313,616.979,163.5,616.979,163.5Z",
    transform: "translate(-568.311 -155.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M635.937,171.809a1.347,1.347,0,0,1,1.016-1.33,2.433,2.433,0,0,1,1.756.277,2.066,2.066,0,0,1,1.165,1.33,2.6,2.6,0,0,1-.8,2,4.132,4.132,0,0,1-.979.958,1.549,1.549,0,0,1-1.318.2,1.653,1.653,0,0,1-.826-.785,3.024,3.024,0,0,1,.649-3.664",
    transform: "translate(-587.392 -164.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M606.773,159.117a10.484,10.484,0,0,1-1.173.388,6.031,6.031,0,0,0-3.8,4.09,9.385,9.385,0,0,1-.306,1.194c-.07,0-.132-.483,0-1.264a5.519,5.519,0,0,1,4.011-4.309A2.329,2.329,0,0,1,606.773,159.117Z",
    transform: "translate(-567.33 -157.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M628.411,178.853a3.163,3.163,0,0,1,.132-1.239,1.186,1.186,0,0,1,.913-.785,1,1,0,0,1,1.024.826,1.239,1.239,0,0,1-.624,1.215,1.611,1.611,0,0,1-1.4.041",
    transform: "translate(-583.167 -168.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M630.23,179.205c0-.033.1-.066.219-.174a.748.748,0,0,0,.26-.525.727.727,0,0,0-.24-.533c-.116-.112-.219-.153-.211-.186s.128-.041.3.062a.756.756,0,0,1-.025,1.305C630.358,179.251,630.23,179.23,630.23,179.205Z",
    transform: "translate(-584.243 -168.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M611.469,172.393v-.124a1.493,1.493,0,0,1,.037-.368,1.975,1.975,0,0,1,.715-1.14,2.069,2.069,0,1,1,0,3.268,1.975,1.975,0,0,1-.715-1.14,1.493,1.493,0,0,1-.037-.368v-.128a1.614,1.614,0,0,0,.1.475,1.967,1.967,0,0,0,.727,1.041,1.888,1.888,0,1,0,0-3.028,1.967,1.967,0,0,0-.727,1.041C611.49,172.22,611.49,172.4,611.469,172.393Z",
    transform: "translate(-573.232 -164.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M600.419,172.393v-.124a1.49,1.49,0,0,1,.037-.368,1.975,1.975,0,0,1,.715-1.14,2.069,2.069,0,1,1,0,3.268,1.975,1.975,0,0,1-.715-1.14,1.49,1.49,0,0,1-.037-.368v-.128a1.614,1.614,0,0,0,.1.475,1.979,1.979,0,0,0,.723,1.041,1.913,1.913,0,0,0,1.8.252,1.884,1.884,0,0,0,0-3.532,1.913,1.913,0,0,0-1.8.252,1.979,1.979,0,0,0-.723,1.041C600.436,172.22,600.44,172.4,600.419,172.393Z",
    transform: "translate(-566.747 -164.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M610,175.337c0-.062.161-.107.364-.107s.364.045.364.107-.165.107-.364.107S610,175.4,610,175.337Z",
    transform: "translate(-572.37 -167.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M620.9,176.34a7.581,7.581,0,0,1,1.772.24,7.5,7.5,0,0,1,1.735.45,7.344,7.344,0,0,1-1.776-.24A7.5,7.5,0,0,1,620.9,176.34Z",
    transform: "translate(-578.767 -167.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M593.18,274.661l3.164,66.812,10.142.215-2.631-57.736,6.866,57.492,10.357.256-8.105-67.771",
    transform: "translate(-562.498 -225.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M608.075,342.909c-.058,0-.789-14.93-1.628-33.35s-1.475-33.354-1.413-33.359.81,14.926,1.636,33.35S608.137,342.9,608.075,342.909Z",
    transform: "translate(-569.453 -226.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M637.785,344.316c-.062,0-1.884-14.492-4.073-32.384s-3.916-32.4-3.854-32.413,1.88,14.492,4.069,32.388S637.843,344.312,637.785,344.316Z",
    transform: "translate(-584.023 -228.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M604.941,213.993l5.2-6.5-6.387-6.44h0a11.43,11.43,0,0,0-4.408-2.855,9.088,9.088,0,0,0-2.528-.508v-.516l-2.8.054s-.145.442-.3.942c-.149.413-.223,1.215-.413,1.215s-.463-.826-.735-1.239l-.479-.963-2.586-.124v.649a15.8,15.8,0,0,0-4.875,1.458h0l-9.539,3.867,3.057,8.432,6.469-2.177c-.041.116-.087.231-.12.351a4.131,4.131,0,0,0,1.049,4.036l-.124,6.8-2.892,9.055,19.792.207-2.251-9.778,1.024-9.692Z",
    transform: "translate(-551.882 -180.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M612.413,197.63a1.69,1.69,0,0,1-.136.6l-.2.624c-.045.12-.078.235-.136.376a.38.38,0,0,1-.174.207.306.306,0,0,1-.3-.021,10.046,10.046,0,0,1-1.652-1.239,10.21,10.21,0,0,1,1.772,1.058c.153.145.227-.223.322-.438l.248-.611A1.846,1.846,0,0,1,612.413,197.63Z",
    transform: "translate(-572.258 -180.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M624.1,198.564a5.75,5.75,0,0,1-1.694,1.723l-.145.1-.087.062-.062-.091a5.259,5.259,0,0,1-.93-2.041c.058,0,.413.9,1.107,1.921l-.149-.029.136-.1C623.349,199.345,624.047,198.522,624.1,198.564Z",
    transform: "translate(-578.931 -180.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M617.144,232.975a1.451,1.451,0,0,1-.025-.306c0-.223,0-.516-.029-.884v-3.247c.05-2.743.178-6.527.339-10.708s.3-7.944.413-10.7c.033-1.355.062-2.479.083-3.247V203a1.405,1.405,0,0,1,.021-.31,2.748,2.748,0,0,0,.025.306c.025.2,0,.516.029.884v3.247c-.05,2.743-.178,6.531-.343,10.712s-.3,7.944-.413,10.7c-.037,1.351-.066,2.454-.087,3.243v.884A1.735,1.735,0,0,1,617.144,232.975Z",
    transform: "translate(-576.531 -183.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M622.414,214.735c0-.025.169-.054.322.145a.475.475,0,0,1,.083.413.487.487,0,0,1-.413.339.479.479,0,0,1-.483-.207.492.492,0,0,1-.041-.413c.091-.231.269-.256.269-.231a.7.7,0,0,0-.12.273.376.376,0,0,0,.058.269.3.3,0,0,0,.285.1.289.289,0,0,0,.244-.182.363.363,0,0,0-.021-.273C622.534,214.8,622.406,214.768,622.414,214.735Z",
    transform: "translate(-579.327 -190.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M622.762,231.295c0-.025.149-.05.289.116a.442.442,0,0,1,.087.355.418.418,0,0,1-.756.124.384.384,0,0,1,0-.372c.116-.194.289-.165.277-.136a.466.466,0,0,0-.141.2.207.207,0,0,0,.24.285.244.244,0,0,0,.165-.372C622.861,231.365,622.758,231.328,622.762,231.295Z",
    transform: "translate(-579.609 -200.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M581.617,218.763a8.679,8.679,0,0,1-.5-1.2c-.314-.806-.711-1.805-1.144-2.912l-1.2-2.892a8.512,8.512,0,0,1-.471-1.21,7.1,7.1,0,0,1,.607,1.148c.347.723.8,1.739,1.26,2.892s.826,2.181,1.091,2.945A6.734,6.734,0,0,1,581.617,218.763Z",
    transform: "translate(-553.765 -187.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M649.584,220.189a38.966,38.966,0,0,1-2.892,3.131,42.152,42.152,0,0,1-3.032,2.983,88.689,88.689,0,0,1,5.924-6.114Z",
    transform: "translate(-592.125 -193.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M6.023,0H7.99a6.04,6.04,0,0,1,6.056,6.056V19.449H0V6.056A6.04,6.04,0,0,1,6.023,0Z",
    transform: "translate(40.137 51.814) rotate(-101.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M650.974,231.292l-21.1,4.362h0a1.6,1.6,0,0,1,1.239-1.884l17.983-3.718a1.6,1.6,0,0,1,1.884,1.239Z",
    transform: "translate(-584.014 -199.371)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(48.784 34.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.824,238.27a6.46,6.46,0,0,1-1.132.31c-.7.169-1.677.38-2.755.607s-2.066.413-2.776.541a6.428,6.428,0,0,1-1.161.165,6.215,6.215,0,0,1,1.128-.314c.706-.165,1.681-.38,2.76-.6s2.066-.413,2.772-.541a6.489,6.489,0,0,1,1.165-.165Z",
    transform: "translate(-637 -238.27)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(48.719 38.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.524,250.025c-.05-.326-.1-.653-.145-.975a50.814,50.814,0,0,0-6.787,6.643,7.961,7.961,0,0,0-1.5,2.243,2.962,2.962,0,0,0,.112,2.615l5.482-1.239Z",
    transform: "translate(-636.841 -249.05)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M652.9,238.306a6.329,6.329,0,0,0-.029-8.341L647.6,224l-4.185,5.185c.186.124,4.511,5.259,4.511,5.259l-6.61,8.233a5.023,5.023,0,0,0-1.041,4.6l.88,1.847a2.718,2.718,0,0,0,3.557,1.305l1.582-.711a.587.587,0,0,0,.149-.979l-.388-.335a1.351,1.351,0,0,0-1.029-.33l-2.012.207-.095-.372h0Z",
    transform: "translate(-590.021 -195.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M650.659,282.961a4.422,4.422,0,0,1-.636.24,4.594,4.594,0,0,1-1.619.38,1.339,1.339,0,0,1-.851-.413,2.215,2.215,0,0,1-.438-.624,1.082,1.082,0,0,1-.153-.673c.037,0,.074.252.285.6a2.433,2.433,0,0,0,.442.549,1.24,1.24,0,0,0,.727.355,6.2,6.2,0,0,0,1.562-.31A1.455,1.455,0,0,1,650.659,282.961Z",
    transform: "translate(-594.059 -229.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M650.277,283a5.74,5.74,0,0,1-1.516.533,1.652,1.652,0,0,1-1.165-.107c-.273-.153-.351-.347-.33-.355a2.8,2.8,0,0,0,.413.219,1.768,1.768,0,0,0,1.053.033A6.172,6.172,0,0,1,650.277,283Z",
    transform: "translate(-594.239 -230.465)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.339 101.039)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M109.865,263.232c-.19-.05-3.945,5.465-4.069,10.212a12.2,12.2,0,0,0,.05,1.392,17.429,17.429,0,0,0,1.186,4.837c3.173,8.018,6.449,17.528,6.5,19.693.165,6.676,3.053,36.643,3.053,36.643l6.333.165,1.008-36.8-2.247-36.44Z",
    transform: "translate(-104.312 -219.362)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M144.92,275.12s8.564,27.794,8.027,36.767-7.064,31.314-7.064,31.314Z",
    transform: "translate(-127.275 -226.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M105.729,263.76s-4.767,6.139-1.421,15.8c3.3,9.588.938,21.3.938,21.3s4.218-3.164,7.209-1.768c3.4,1.59,5.672,3.491,9.915,1.652,4.408-1.925,7.911-3.007,11.939.76l-6.23-21.73-3.6-13.835Z",
    transform: "translate(-102.741 -219.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M154.8,232.613c-1.045-.1-2.925-9.683-2.925-9.683l-7.725,2.582s-.231,1.458,4.42,10.741c0,0,2.739,4.875,6.159,4.652Z",
    transform: "translate(-126.82 -195.886)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M119.059,200.018s5.85-.574,8.572,6.531h0l.025.066c.05.132.1.269.145.413l2.276,6.407-6.271,3.127v.711l.682,12.852-20-3.78,1.615-2.326c1.553-2.144,1.2-5.156.566-7.725l-.215-.876-2.71,1.417a18.255,18.255,0,0,1-1.462-8.936v-.227a8.981,8.981,0,0,1,9.568-8.134Z",
    transform: "translate(-102.207 -182.145)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(7.268 25.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.8,218.67a57.073,57.073,0,0,0,5.189,12.125c.2.368.632.781.946.512.24-.2.112-.591-.033-.868l-6.1-11.769",
    transform: "translate(-119.8 -218.67)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M153.28,224.16a5.6,5.6,0,0,1,.413.975c.219.611.529,1.446.826,2.4a3.623,3.623,0,0,1,.153,1.417,3.425,3.425,0,0,1-.351,1.107,3.717,3.717,0,0,1-.566.9,8.807,8.807,0,0,1,.413-.958,3.536,3.536,0,0,0,.293-1.066,3.59,3.59,0,0,0-.161-1.338c-.281-.9-.537-1.723-.756-2.417A4.841,4.841,0,0,1,153.28,224.16Z",
    transform: "translate(-132.181 -196.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M137.687,172.64a4.879,4.879,0,0,0,2.326,4.152,10.369,10.369,0,0,1,1.148.682,1.45,1.45,0,0,1,.62,1.132c-.029.7-.735,1.144-1.359,1.462a1.731,1.731,0,1,1-2.479,2.392,3.181,3.181,0,0,1-2.338,2.826,4.429,4.429,0,0,1-3.718-.764,7.465,7.465,0,0,1-2.367-3.074",
    transform: "translate(-118.237 -166.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M152.366,173.738a.449.449,0,0,1,.078.3.946.946,0,0,1-.413.735,1.281,1.281,0,0,1-1.26,0,2.681,2.681,0,0,1-1.091-1.074,6.771,6.771,0,0,1-.88-2.6,3.33,3.33,0,0,1,0-1.132c.033,0,.045.413.169,1.111a7.779,7.779,0,0,0,.917,2.508,2.6,2.6,0,0,0,.963,1.041,1.157,1.157,0,0,0,1.086.033.892.892,0,0,0,.413-.611C152.387,173.849,152.346,173.742,152.366,173.738Z",
    transform: "translate(-129.524 -164.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M131.816,178.088c.091-1.586.2-3.16.2-3.16a3.023,3.023,0,0,0,2.689-2.784c.153-2.516,0-8.308,0-8.308l-4.619-2.256L125,165.426l.521,12.612a3.144,3.144,0,0,0,2.954,3.012h0a3.14,3.14,0,0,0,3.342-2.962Z",
    transform: "translate(-115.584 -159.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M146.364,176.812a.322.322,0,1,1-.322-.322A.322.322,0,0,1,146.364,176.812Z",
    transform: "translate(-127.745 -168.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M146.183,175.866c-.041.041-.277-.161-.624-.178s-.607.145-.644.1.025-.1.14-.174a.851.851,0,0,1,1.012.062C146.183,175.767,146.216,175.846,146.183,175.866Z",
    transform: "translate(-127.266 -168.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M137.34,176.812a.318.318,0,0,1-.318.322.322.322,0,1,1,0-.644.318.318,0,0,1,.318.322Z",
    transform: "translate(-122.451 -168.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M136.923,175.866c-.041.041-.281-.161-.628-.178s-.6.145-.64.1.025-.1.14-.174a.851.851,0,0,1,1.012.062C136.911,175.767,136.944,175.846,136.923,175.866Z",
    transform: "translate(-121.831 -168.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M141.672,179.189a2.2,2.2,0,0,1,.566-.07c.087,0,.178,0,.2-.083a.459.459,0,0,0-.05-.277c-.078-.235-.157-.467-.235-.715-.165-.5-.31-.967-.413-1.3a2.276,2.276,0,0,1-.128-.554,2.429,2.429,0,0,1,.219.521c.12.33.277.789.442,1.3.074.244.149.479.227.715a.529.529,0,0,1,.029.359.293.293,0,0,1-.293.132A2.7,2.7,0,0,1,141.672,179.189Z",
    transform: "translate(-125.332 -168.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M138.919,184.231a6.723,6.723,0,0,0,1.677.578.963.963,0,0,1-1.148.326C138.7,184.822,138.919,184.231,138.919,184.231Z",
    transform: "translate(-123.719 -173.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M137.27,192.288a6.283,6.283,0,0,1-3.33-1.128,3.247,3.247,0,0,0,3.276,1.743Z",
    transform: "translate(-120.831 -177.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M125.323,159.575c-2.479-2.586-4.2-2.066-5.18-2.066a7.849,7.849,0,0,0-5.445,3.144h0a10.925,10.925,0,0,0-1.8,3.908,19.671,19.671,0,0,0,.025,2.516,3.05,3.05,0,0,1-.826,2.3c-.413.351-.958.554-1.2,1.029a1.334,1.334,0,0,0,.554,1.611,3,3,0,0,0,1.793.368,2.536,2.536,0,0,0,2.066,2.7,2.45,2.45,0,0,0,1.776-.459,14.3,14.3,0,0,0,1.338,1.148q.157-5.486-.231-10.968c1.677-.3,4.685-1.2,5.209-3.887a9.626,9.626,0,0,0,3.036,3.52C126.447,164.441,127.827,162.165,125.323,159.575Z",
    transform: "translate(-107.257 -157.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M129.15,168.506a4.132,4.132,0,0,1,1.029,0,5.341,5.341,0,0,0,2.384-.281,2.243,2.243,0,0,0,1-.806,2.785,2.785,0,0,0,.413-.991c.12-.607.062-1,.1-1.008a2.115,2.115,0,0,1,.058,1.037,2.71,2.71,0,0,1-.384,1.074,2.388,2.388,0,0,1-1.078.9,4.92,4.92,0,0,1-2.479.231A5.572,5.572,0,0,1,129.15,168.506Z",
    transform: "translate(-118.02 -162.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M113.31,174.98a1.293,1.293,0,0,0,.413-.058,1.107,1.107,0,0,0,.682-.826,2.751,2.751,0,0,0-.306-1.628,6.61,6.61,0,0,1-.355-.979,3.3,3.3,0,0,1-.07-1.128,4.594,4.594,0,0,1,.748-2.024A7.75,7.75,0,0,1,115.557,167c.359-.347.669-.6.884-.777a1.475,1.475,0,0,1,.351-.252,13.1,13.1,0,0,1-1.124,1.14,8.421,8.421,0,0,0-1.074,1.334,4.627,4.627,0,0,0-.7,1.937,3.33,3.33,0,0,0,.062,1.058,6.778,6.778,0,0,0,.335.95,2.805,2.805,0,0,1,.269,1.743,1.173,1.173,0,0,1-.806.859.718.718,0,0,1-.33,0C113.343,175,113.31,174.988,113.31,174.98Z",
    transform: "translate(-108.723 -162.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M137.461,440.86v-.826l-6.531-.124v2.549l.413.025c1.8.1,9.142.388,10.328.025C142.993,442.112,137.461,440.86,137.461,440.86Z",
    transform: "translate(-119.064 -323.23)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(11.845 117.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M133.231,443.525a2.272,2.272,0,0,0-.826-1.388,2.194,2.194,0,0,0-1.524-.475v1.818Z",
    transform: "translate(-130.88 -441.657)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(11.828 118.337)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M140.1,443.92s1.937.558,1.7.88-7.68.306-10.96,0v-.145l8.675.083S139.722,443.953,140.1,443.92Z",
    transform: "translate(-130.84 -443.92)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M130.76,445.61h.112l.322.021,1.181.054c1,.037,2.384.07,3.908.074s2.892-.025,3.908-.058l1.186-.05h0l-1.181.021c-1,0-2.384.037-3.908.037s-2.892-.029-3.908-.054l-1.181-.025h-.322Z",
    transform: "translate(-118.965 -326.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M151.855,444.8a2.772,2.772,0,0,1,.223-.566,2.613,2.613,0,0,1,.413-.454.893.893,0,0,0-.471.413A.913.913,0,0,0,151.855,444.8Z",
    transform: "translate(-131.343 -325.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M146.906,442.741a.792.792,0,0,0,.207-.248.723.723,0,0,0,.14-.293.779.779,0,0,0-.207.252C146.952,442.6,146.89,442.729,146.906,442.741Z",
    transform: "translate(-128.439 -324.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M145.637,442.314a1.05,1.05,0,0,0,.227-.153c.112-.1.194-.2.178-.215s-.116.054-.227.153S145.62,442.3,145.637,442.314Z",
    transform: "translate(-127.695 -324.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M144.83,441.294a.781.781,0,0,0,.343.041.768.768,0,0,0,.339-.033.826.826,0,0,0-.339-.045C144.983,441.257,144.83,441.269,144.83,441.294Z",
    transform: "translate(-127.222 -324.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M144.56,440.3a.677.677,0,0,0,.38.112.648.648,0,0,0,.388-.054,2.384,2.384,0,0,0-.384-.025,2.125,2.125,0,0,0-.384-.033Z",
    transform: "translate(-127.064 -323.459)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M147.45,441.318a1.19,1.19,0,0,0,.413,0,2.284,2.284,0,0,0,.446-.1,1.207,1.207,0,0,0,.256-.107.219.219,0,0,0,.1-.128.174.174,0,0,0-.062-.169.768.768,0,0,0-.95.223.744.744,0,0,0-.136.281.256.256,0,0,0,0,.112,1.239,1.239,0,0,1,.194-.355.723.723,0,0,1,.355-.231.657.657,0,0,1,.5.033c.066.05.041.128-.033.174a1.654,1.654,0,0,1-.235.1,2.8,2.8,0,0,1-.434.112C147.611,441.305,147.45,441.305,147.45,441.318Z",
    transform: "translate(-128.76 -323.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M146.937,441.04a.388.388,0,0,0,.05-.289.694.694,0,0,0-.112-.306.413.413,0,0,0-.351-.215.165.165,0,0,0-.128.194.5.5,0,0,0,.07.186,1.19,1.19,0,0,0,.2.252.612.612,0,0,0,.24.169,2.665,2.665,0,0,1-.2-.207,1.473,1.473,0,0,1-.178-.252c-.054-.087-.1-.248,0-.264s.211.091.273.178a.682.682,0,0,1,.12.273A1.508,1.508,0,0,1,146.937,441.04Z",
    transform: "translate(-128.139 -323.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M130.65,441.527h.483a2.123,2.123,0,0,1,1.049.434,2.094,2.094,0,0,1,.653.929c.1.277.107.467.124.463a.343.343,0,0,0,0-.128,1.678,1.678,0,0,0-.07-.351,2.066,2.066,0,0,0-.657-.975,1.987,1.987,0,0,0-1.095-.413,1.608,1.608,0,0,0-.359,0A.441.441,0,0,0,130.65,441.527Z",
    transform: "translate(-118.9 -324.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M138.25,444.12a5.4,5.4,0,0,0,1.9.021c0-.025-.413,0-.954,0S138.254,444.095,138.25,444.12Z",
    transform: "translate(-123.361 -325.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M135.16,444.116s.033.087.078.186.066.186.087.182.037-.1,0-.215S135.172,444.1,135.16,444.116Z",
    transform: "translate(-121.547 -325.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M134,442.665a.4.4,0,0,0,.091.149c.066.066.136.112.153.1s-.029-.087-.1-.153S134,442.649,134,442.665Z",
    transform: "translate(-120.866 -324.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M132.33,441.951c0,.025.091.021.186.058s.165.083.182.07-.037-.107-.153-.149A.261.261,0,0,0,132.33,441.951Z",
    transform: "translate(-119.886 -324.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M131.15,441.668c0,.021.029.054.083.074s.1.021.112,0-.029-.054-.083-.074S131.158,441.647,131.15,441.668Z",
    transform: "translate(-119.194 -324.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M113.48,255.05s.744,5.73,6.321,5.523a84.858,84.858,0,0,0,11.121-1.239l-.058-1.086Z",
    transform: "translate(-108.823 -214.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M141.958,237.783c-.5-.8-3.9,1.1-4.205,1.239s-.512-.293-.235-.413c.413-.161,4.544-1.946,4.077-2.731-.264-.413-1,.112-1,.112s-3.768,1.958-3.978,1.578,1.954-1.607,2.714-1.966.892-.859.454-1.062c-.293-.136-2.652.913-3.4,1.285s-2.772,1.438-2.2.1a3.689,3.689,0,0,0,.256-2.892.454.454,0,0,0-.781.359,5.321,5.321,0,0,1-.31,1.429,3.483,3.483,0,0,1-.545,1.041c-.281.368-.533.665-.756.913-2.173.76-8.374,2.681-14.165,2.152-1.049-.1-3.718-7.1-3.718-7.1l-7.213,3.718s-.132.392,3.156,6.792c4.478,8.712,24.708-.326,24.708-.326v-.021a43.907,43.907,0,0,0,4.544-1.157c2.032-.735,1.971-.921,1.842-1.14-.339-.6-3.627,1.157-3.14.368S142.338,238.39,141.958,237.783Z",
    transform: "translate(-104.996 -201.11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2fb7fca4.svg";
export { ForwardRef as ReactComponent };